<div class="campaign-locations-container">
  <app-closable-bottom-sheet-handle (close)="close()"
                                    class="closable-bottom-sheet-handle"></app-closable-bottom-sheet-handle>
  <div class="title">{{ 'mobile.locationsList.title' | transloco: {rewardAmount: campaign.reward} }}</div>
  <div class="campaign-location-cards">
    @for (location of campaign.locationsGroup!.locations; track location.id) {
      <div class="location-card">
        <div class="location-card-header">
          <div class="location-card-title">
            <div class="location-card-index">
              {{ $index + 1 }}
            </div>
            <span class="location-card-name">
            {{ location.name }}
          </span>
          </div>
          <button mat-fab class="square-button"
                  (click)="openMapApp(location.address.latitude, location.address.longitude)">
            <img ngSrc="/assets/icons/crosshair-icon.svg" class="navigate-icon" alt="crosshair icon" height="16"
                 width="16">
          </button>
        </div>
        <mat-divider class="location-card-divider"></mat-divider>
        <div class="location-card-address">
          <img ngSrc="/assets/icons/location-Icon.svg" alt="location icon" height="16"
               width="14">
          <span class="location-card-address-text">{{ locationDisplayFunction(location) }}</span>
        </div>
      </div>
    }
  </div>
</div>
